export default "__VITE_ASSET__c_fN55Q0__"